// Angular imports
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// 3rd party imports
import { classToPlain } from 'class-transformer';

// CC-Common imports
import { CCDeviceService, Utils } from 'cc-common';

// Service imports
import { AuthService } from '../auth.service';
import { ScreenService } from './screen.service';
import { ServerErrorService } from './server-error.service';

// Model imports
import { UserActivity } from '../../_models/user-activity';

// Constant imports
import { URLConstants } from '../../_constants/url-constants';

@Injectable({
    providedIn: 'root'
})
export class UserBackgroundService {
    constructor(
        private readonly http: HttpClient,
        private readonly screenService: ScreenService,
        private readonly deviceService: CCDeviceService,
        private readonly authService: AuthService,
        private readonly errorService: ServerErrorService
    ) {}

    logActivity(route: string, action: string, time: Date, info?: string, communityId?: number) {
        if (this.authService.isLoggedIn === true) {
            const userActivity = new UserActivity();

            // if token exists and decodedToken is null
            // we are already checking token is isLoggedIn method
            if (Utils.isNullOrUndefined(this.authService.decodedToken)) {
                this.authService.setDecodedToken();
            }

            if (!!this.authService.decodedToken) {
                userActivity.userId = this.authService.decodedToken.nameid;
                userActivity.alias = this.authService.decodedToken.nameid;
            }

            if (!!userActivity.userId) {
                userActivity.route = route;
                userActivity.activity = action;
                userActivity.additionalInfo = info;
                userActivity.dateTimeStamp = time;
                userActivity.communityId = communityId ? communityId : -1;

                // Client IP
                userActivity.clientIP = null;

                // ServerName
                userActivity.serverName = null;

                // Screen
                userActivity.screenSize = this.screenService.getCurrentScreenSize;

                // Device
                const deviceInfo = this.deviceService.deviceInfomation;

                if (deviceInfo !== undefined) {
                    userActivity.browser = deviceInfo.browser;
                    userActivity.browserVersion = deviceInfo.browser_version;
                    userActivity.operatingSystem = deviceInfo.os;
                    userActivity.osVersion = deviceInfo.os_version;
                    userActivity.device = deviceInfo.device;
                    userActivity.userAgent = deviceInfo.userAgent;
                }

                this.http.post(URLConstants.ccUserActivityApiUrl, classToPlain(userActivity)).subscribe(
                    () => {
                        // Do nothing
                    },
                    () => {
                        // Do nothing
                    }
                );
            }
        }
    }
}
